import {
	CAMPAIGNS_SETTINGS_ADD_FIELD,
	CAMPAIGNS_SETTINGS_UPDATE_FIELD_VALUE,
	CAMPAIGNS_SETTINGS_REMOVE_FIELD,
	CAMPAIGNS_SETTINGS_UPDATE_FIELD,
	SETTINGS_SAVED,
	ADD_CAMPAIGN,
	ADD_CAMPAIGNS,
	UPDATE_CAMPAIGN,
	REMOVE_CAMPAIGN,
	CAMPAIGNS_SETTINGS_RESET,
} from "../../../constants";

export const updateTypeValue = ( name, val, fieldKey, settingsProperty ) => {
	return {
		type: CAMPAIGNS_SETTINGS_UPDATE_FIELD_VALUE,
		payload: {
			name: name,
			value: val,
			fieldKey: fieldKey,
			settingsProperty: settingsProperty
		}
	};
};

export const changeSettingsField = ( settingsProperty, childSnap ) => {
	return {
		type: CAMPAIGNS_SETTINGS_UPDATE_FIELD,
		payload: {
			settingsProperty: settingsProperty,
			childSnap: childSnap,
		}
	}
};

export const addSettingsField = ( settingsProperty, childSnap) => {
	return {
		type: CAMPAIGNS_SETTINGS_ADD_FIELD,
		payload: {
			settingsProperty: settingsProperty,
			childSnap: childSnap
		}
	};
};

export const resetSettings = () => {
	return {
		type: CAMPAIGNS_SETTINGS_RESET
	}
};

export const removeSettingsField = ( settingsProperty, childSnap) => {
	return {
		type: CAMPAIGNS_SETTINGS_REMOVE_FIELD,
		payload: {
			settingsProperty: settingsProperty,
			childSnap: childSnap
		}
	};
};

export const settingsSaved = () => {
	return {
		type: SETTINGS_SAVED,
		payload: {
			message: 'De instellingen zijn opgeslagen'
		}
	}
};

export const addCampaign = ( campaignSnap ) => {
	return {
		type: ADD_CAMPAIGN,
		payload: {
			campaign: campaignSnap
		}
	}
}

export const addCampaigns = ( campaigns ) => {
	return {
		type: ADD_CAMPAIGNS,
		payload: {
			campaigns: campaigns
		}
	}
}

export const removeCampaign = ( campaignSnap ) => {
	return {
		type: REMOVE_CAMPAIGN,
		payload: {
			campaign: campaignSnap
		}
	}
}

export const updateCampaign = ( campaignSnap ) => {
	return {
		type: UPDATE_CAMPAIGN,
		payload: {
			campaign: campaignSnap
		}
	}
}


// WEBPACK FOOTER //
// ./src/api/settings/campaigns/actions.js